import dayjs from 'dayjs';

export const providers = [
  'pragmatic',
  'netent',
  'playngo',
  'evoplay',
  'gameart',
  'platipus',
  'betsoft',
  'amatic',
  'wazdan',
  'playson',
  'quickspin',
  'bsw',
  'playtech',
  'dlv',
  'fishing',
  'endorphina',
  'merkur',
  'kajot',
  'wacs',
  'gaminator',
  'mrslotty',
  'igt',
  'greentube',
  'aristocrat',
  'apollo',
  'inbet',
  'konami',
  'austria',
  'flg',
  'cqgaming',
  'relaxgaming',
  'booongo',
  'igrosoft',
  'nolimit',
  'wmg',
  'elbet',
  'redrake',
  'spribe',
  'pragmaticlive',
  'evolutionlive',
  'pragmaticlive',
  'tvbet',
  'xpg',
  'goldenrace',
  'universalrace',
];

export const diffRangeItems = {
  today: [
    { name: 'precedingDay', value: { count: 1, type: 'day' } },
    { name: 'sameDayLastWeek', value: { count: 1, type: 'week' } },
    { name: 'sameDayLastMonth', value: { count: 1, type: 'month' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  yesterday: [
    { name: 'precedingDay', value: { count: 1, type: 'day' } },
    { name: 'sameDayLastWeek', value: { count: 1, type: 'week' } },
    { name: 'sameDayLastMonth', value: { count: 1, type: 'month' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  currentWeek: [
    { name: 'precedingWeek', value: { count: 1, type: 'week' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'sameWeekLastMonth', value: { count: 1, type: 'month' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  currentMonth: [
    { name: 'precedingMonth', value: { count: 1, type: 'month' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],

  lastWeek: [
    { name: 'precedingWeek', value: { count: 1, type: 'week' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  lastMonth: [
    { name: 'precedingMonth', value: { count: 1, type: 'month' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  lastMonth: [
    { name: 'precedingMonth', value: { count: 1, type: 'month' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  lastYear: [
    { name: 'samePeriodLastYear', value: { count: 1, type: 'year' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  manualCompare: [{ name: 'manualCompare', value: 'manualCompare' }],
};

export const sortFieldsForMobile = ['provider', 'betAmount', 'winAmount', 'betCount', 'incomeAmount'];

export const zeroDaysFilterValue = [
  {
    text: 'addDays',
    value: null,
    value2: null,
  },
];

export const daysFilterValue = [
  {
    text: 'today',
    value: new Date(dayjs().startOf('day').add(0, 'day')),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
  {
    text: 'yesterday',
    value: new Date(dayjs().startOf('day').add(-1, 'day')),
    value2: new Date(dayjs().startOf('day').add(0, 'day')),
  },
  {
    text: 'currentWeek',
    value: new Date(dayjs().startOf('day').day(1)),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
  {
    text: 'currentMonth',
    value: new Date(dayjs().startOf('day').date(1)),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
  {
    text: 'lastWeek',
    value: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').day() + 7 - 1), 'day'),
    ),
    value2: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').day() + 0 - 1), 'day'),
    ),
  },
  {
    text: 'lastMonth',
    value: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').date() + dayjs().startOf('day').add(-1, 'month').daysInMonth() - 1), 'day'),
    ),
    value2: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').date() + 0 - 1), 'day'),
    ),
  },
  {
    text: 'lastYear',
    value: new Date(dayjs().startOf('year')),
    value2: new Date(dayjs().endOf('year')),
  },
];

export const daysFilterValueMobile = [
  {
    text: 'today',
    value: new Date(dayjs().startOf('day').add(0, 'day')),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
  {
    text: 'yesterday',
    value: new Date(dayjs().startOf('day').add(-1, 'day')),
    value2: new Date(dayjs().startOf('day').add(0, 'day')),
  },
  {
    text: 'lastWeek',
    value: new Date(dayjs().add(-(dayjs().day() + 7 - 1), 'day')),
    value2: new Date(dayjs().add(-(dayjs().day() + 0 - 1), 'day')),
  },
  {
    text: 'lastMonth',
    value: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').date() + dayjs().startOf('day').add(-1, 'month').daysInMonth() - 1), 'day'),
    ),
    value2: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').date() + 0 - 1), 'day'),
    ),
  },
  {
    text: 'lastYear',
    value: new Date(dayjs().startOf('year')),
    value2: new Date(dayjs().endOf('year')),
  },
];

export const structure = [
  {
    name: 'allUsers',
    value: 'allUsers',
  },
  {
    name: 'directOnly',
    value: 'directOnly',
  },
];

export const searchInItems = [
  {
    name: 'agent',
    value: '6',
    role: '6',
  },
  {
    name: 'user',
    value: '0',
    role: '0',
  },
  {
    name: 'referralPlayers',
    value: 'referralPlayer',
    role: '0',
    isReferral: true,
  },
];

export const providerItems = [
  {
    name: 'all',
    value: '',
  },
  {
    name: 'PRAGMATIC-SLOTS',
    value: 'PRAGMATIC-SLOTS',
  },
  {
    name: 'PRAGMATIC-LIVE-CASINO',
    value: 'PRAGMATIC-LIVE-CASINO',
  },
  {
    name: 'PRAGMATIC-BJ',
    value: 'PRAGMATIC-BJ',
  },
  {
    name: 'BELATRA',
    value: 'BELATRA',
  },
  {
    name: 'OUTCOMEBET',
    value: 'OUTCOMEBET',
  },
  {
    name: 'EVOPLAY',
    value: 'EVOPLAY',
  },
  {
    name: 'EVOLUTION',
    value: 'EVOLUTION',
  },
  {
    name: 'EZUGI',
    value: 'EZUGI',
  },
  {
    name: 'POPOKGAMING',
    value: 'POPOKGAMING',
  },
  {
    name: 'TVBET',
    value: 'TVBET',
  },
  {
    name: 'JACKTOP',
    value: 'JACKTOP',
  },
  {
    name: 'VIVOGAMING',
    value: 'VIVOGAMING',
  },
  {
    name: 'REDRAKE',
    value: 'REDRAKE',
  },
  {
    name: 'BGAMING',
    value: 'BGAMING',
  },
  {
    name: 'BETONGAMES',
    value: 'BETONGAMES',
  },
  {
    name: 'HACKSAW',
    value: 'HACKSAW',
  },
  {
    name: 'AMIGOGAMING',
    value: 'AMIGOGAMING',
  },
  {
    name: 'PLATIPUS',
    value: 'PLATIPUS',
  },
  {
    name: 'FIABLE',
    value: 'FIABLE',
  },
  {
    name: 'BSWGAMES',
    value: 'BSWGAMES',
  },
  {
    name: 'INBET',
    value: 'INBET',
  },
  {
    name: 'SOFTGAMING',
    value: 'SOFTGAMING',
  },
  {
    name: 'SLOTEGRATOR',
    value: 'SLOTEGRATOR',
  },
  {
    name: 'UNIVERSALRACE',
    value: 'UNIVERSALRACE',
  },
  {
    name: 'BETRADAR',
    value: 'BETRADAR',
  },
  {
    name: 'LINE1X',
    value: 'LINE1X',
  },
  {
    name: 'FLG',
    value: 'FLG',
  },
  {
    name: 'UPGAMING',
    value: 'UPGAMING',
  },
  {
    name: 'KAGAMING',
    value: 'KAGAMING',
  },
  {
    name: '100HP',
    value: '100HP',
  },
  {
    name: 'ULTIM8',
    value: 'GR8',
  },
  {
    name: 'AMUSNET',
    value: 'AMUSNET',
  },
  {
    name: 'WINFINITY-SLOTS',
    value: 'WINFINITY-SLOTS',
  },
  {
    name: 'WINFINITY-LIVE-CASINO',
    value: 'WINFINITY-LIVE-CASINO',
  },
  {
    name: 'BLUEJACK',
    value: 'BLUEJACK',
  },
];

export const statusBets = [
  {
    name: 'win',
    value: 1,
  },
  {
    name: 'bet',
    value: 2,
  },
  {
    name: 'refund',
    value: 3,
  },
];

export const statusSportBets = [
  {
    name: 'wait',
    value: 2,
  },
  {
    name: 'win',
    value: 1,
  },
  {
    name: 'return',
    value: 3,
  },
  // {
  //   name: 'loss',
  //   value: 4,
  // },
  // {
  //   name: 'sold',
  //   value: 5,
  // },
];

export const gameTypes = [
  {
    name: 'all',
    value: 'all',
  },
  {
    name: 'slots',
    value: 'slots',
  },
  {
    name: 'liveCasino',
    value: 'live-casino',
  },
  // {
  //   name: 'fiable',
  //   value: 'fiable',
  // },
];

export const DAY_MILLISECONDS = 86_400_000;
